import { render, staticRenderFns } from "./CardFormHelper.vue?vue&type=template&id=4a54c574&scoped=true&"
import script from "./CardFormHelper.vue?vue&type=script&lang=js&"
export * from "./CardFormHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54c574",
  null
  
)

export default component.exports